// Statut d'un mois renvoyé par la synthèse annuelle
export const MONTH_STATUS = {
    not_declared: "not_declared",
    not_validated: "not_validated",
    finalized: "finalized",
    upcoming: "upcoming",
    unavailable: "unavailable",
};

export const MONTH_STATUS_DETAILS = {
    [MONTH_STATUS.not_declared]: { label: "Non déclaré", color: "#F0B041" },
    [MONTH_STATUS.not_validated]: { label: "Non validé", color: "#C5CBFA" },
    [MONTH_STATUS.finalized]: { label: "Finalisé", color: "#5B5FC7" },
    [MONTH_STATUS.upcoming]: { label: "À venir", color: "#E1DFDD" },
    [MONTH_STATUS.unavailable]: { label: "Indisponible", color: "#EDEBE9" },
};

// couleur d'un mois qui ne correspond pas au filtre État
export const MONTH_DIMMED_COLOR = "#EDEBE9";

export const LEGEND_STATUSES = [
    MONTH_STATUS.not_declared,
    MONTH_STATUS.not_validated,
    MONTH_STATUS.finalized,
    MONTH_STATUS.upcoming,
];

// valeurs acceptées par le paramètre status
export const FILTERABLE_STATUSES = [
    MONTH_STATUS.not_declared,
    MONTH_STATUS.not_validated,
    MONTH_STATUS.finalized,
];

export const MONTHS = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
];

export const SUMMARY_SCOPES = {
    manager: "manager",
    hr: "hr",
};

export const SUMMARY_GRID_COLUMNS =
    "44px minmax(210px, 1.6fr) minmax(190px, 1.3fr) repeat(4, minmax(110px, 1fr)) 44px";
